import React from "react";
import classes from "./TreeItem.module.scss";
import { useState } from "react";

const TreeItem = ({
  category,
  setSelectedCategory,
  setCategoryId,
  setTagListVisible,
}) => {
  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen(!open);
  };

  const handleSelected = (name, id) => {
    setSelectedCategory(name);
    setCategoryId(id);

  };

  return (
    <ul style={{ listStyle: "none" }}>
      <li className={classes.inputOptions}>
        <span
          onClick={() => handleClick()}
          className={open ? classes.caretDown : classes.caret}
        >
          {" "}
        </span>
        <span
          onClick={() => {
            setTagListVisible(false);
            handleSelected(category.Name, category.CategoryId);
          }}
        >
          {category.Name}
        </span>
      </li>
      {open &&
        category?.SubCategory?.map((subCategory) => {
          if (subCategory?.SubCategory?.length > 0) {
            return <TreeItem category={subCategory} />;
          } else {
            return (
              <ul style={{ listStyle: "none" }}>
                <li
                  className={classes.inputOptionsInner}
                  onClick={() => {
                    setTagListVisible(false);
                    handleSelected(subCategory.Name, subCategory.CategoryId);
                  }}
                >
                  {subCategory.Name}
                </li>
              </ul>
            );
          }
        })}
    </ul>
  );
};
export default TreeItem;
